export const DEBUG =
    typeof window !== "undefined" && new URLSearchParams(window.location.search).get("debug3d") === "1";

export const debugState = {
    webgl: false,
    webgl2: false,
    renderer: false,
    firstFrame: false,
    frames: 0,
    contextLost: false,
    fallback: false,
    canvasW: 0,
    canvasH: 0,
    modelScale: 0,
    error: "",
};

export function detectWebGL() {
    const res = { webgl2: false, webgl: false, ok: false, error: "" };
    try {
        const c = document.createElement("canvas");
        let gl = c.getContext("webgl2");
        if (gl) {
            res.webgl2 = true;
            res.ok = true;
            const ext = gl.getExtension("WEBGL_lose_context");
            if (ext) ext.loseContext();
        }
        if (!res.ok) {
            gl = c.getContext("webgl") || c.getContext("experimental-webgl");
            if (gl) {
                res.webgl = true;
                res.ok = true;
                const ext = gl.getExtension("WEBGL_lose_context");
                if (ext) ext.loseContext();
            }
        }
    } catch (e) {
        res.error = String(e);
    }
    debugState.webgl = res.webgl;
    debugState.webgl2 = res.webgl2;
    if (res.error) debugState.error = res.error;
    return res;
}

export function isCompactDevice() {
    return typeof window !== "undefined" && window.innerWidth < 1024;
}

export function isIOS() {
    if (typeof navigator === "undefined") return false;
    return (
        /iP(hone|ad|od)/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
}

export function isSafari() {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent;
    return /Safari/.test(ua) && !/Chrome|CriOS|Edg|Android|OPR/.test(ua);
}
